import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Animations } from './toggle.animation';

@Component({
  selector: 'boi-accordion-item',
  templateUrl: './accordion-item.component.html',
  styleUrls: ['./accordion-item.component.scss'],
  animations: [Animations.preventFirstAnimation, Animations.toggleAnimation]
})
export class AccordionItemComponent {
  @Input() public title: string;
  @Input() public expanded = false;
  @Input() public data: any;
  @Input() public toggleOnHeaderClick = true;

  @Output() public readonly toggle: EventEmitter<any> = new EventEmitter();

  public handleToggle(): void {
    this.expanded = !this.expanded;
  }
}
